<template>
  <MainContent>
    <b-card>
      <ResetCertificationForm
        :activation-key="key"
      />
    </b-card>
  </MainContent>
</template>

<script>
import MainContent from "../../../components/main/MainContent";
import ResetCertificationForm from "../components/ResetCertificationForm";

export default {
  props: ["key"],
  components: {
    MainContent,
    ResetCertificationForm
  }
};
</script>
